import QS from 'qs';
import { fetch } from '../utils/fetch';

export function getIndustryList() {
  return fetch({
    url: '/api/all-industries',
    method: 'get',
  });
}

export function saveIndustry(industry) {
  return fetch({
    url: '/api/industry',
    method: 'post',
    data: QS.stringify(industry),
  });
}


export function deleteIndustry(id) {
  return fetch({
    url: `/api/industry/${id}`,
    method: 'delete',
  });
}

export function getIndustry(id) {
  return fetch({
    url: `/api/industry/${id}`,
    method: 'get',
  });
}

export function updateIndustry(industry) {
  return fetch({
    url: '/api/industry',
    method: 'patch',
    data: QS.stringify(industry),
  });
}
